import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import axios from "axios";

const AddActionOption = () => {
  const [categoryName, setCategoryName] = useState("");
  const [categoryColor, setCategoryColor] = useState("#FA0808");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleAddCategory = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (categoryName === "") {
      return setError("Category name is required.");
    }

    // Add your API call here to add the category
    try {
      const response = await axios.post(
        "http://localhost:8080/action-option/createActionOption",
        {
          name: categoryName,
          color: categoryColor,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Επιτυχής Δημιουργία Δραστηριότητας.");
      setCategoryName("");
      setCategoryColor("#FA0808"); // Reset color to default after adding the category
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Ενεργεία με αυτό το όνομα υπάρχει ήδη.");
      } else {
        setError("Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.");
      }
    }

  };

  return (
    <div className="add-category-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "0px",
          fontWeight: "600",
        }}
      >
        Δημιουργία Δραστηριότητας
      </h4>
      <form
        onSubmit={handleAddCategory}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          alignItems: "center",
        }}
      >
        <TextField
          variant="outlined"
          label="Όνομα Δραστηριότητας"
          placeholder="π.χ. ΓΕΝΙΚΟΣ"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
          }}
        />
        <TextField
          variant="outlined"
          type="color"
          label="Χρώμα Δραστηριότητας"
          value={categoryColor}
          onChange={(e) => setCategoryColor(e.target.value)}
          margin="normal"
          sx={{
            width: "20%",
          }}
          // Custom styling may be required for color input to look consistent
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
          }}
        />
        <button
          className="add-ticket-button__button"
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: "auto",
            padding: "10px 20px",
          }}
          onClick={() => {}}
        >
          <AddIcon />
          <span>ΔΗΜΙΟΥΡΓΙΑ</span>
        </button>
      </form>
    </div>
  );
};

export default AddActionOption;
